import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "Browser Automation", desc: "Playwright and Puppeteer automation for repetitive browser tasks and data handling." },
  { title: "n8n Workflows", desc: "Self-hosted workflow automation across your internal stack and third-party services." },
  { title: "API Integration", desc: "Middleware and process automation that removes manual re-entry and dead spots in operations." },
];

const examples = [
  "Facebook Lead Ad → CRM created → WhatsApp sent in 60s → Saves 10h/month",
  "Invoice uploaded → AI extracts data → Manager approves → Auto-entered in Tally → Saves 10.5h/month",
  "Support email → AI categorises → Ticket created → Auto-reply sent → Routed to team → Saves 12.5h/month",
  "1st of month → Pull GA + Meta + CRM → Generate PDF report → Email to client → Saves 4h/month",
];

const RpaAutomation = () => (
  <StitchFeaturePage
    label="SERVICE · RPA & WORKFLOW AUTOMATION"
    title="Stop doing"
    titleAccent="what software can do."
    subtitle="Every repetitive manual task in your operations — identified and automated."
    features={features}
    ctaLabel="AUTOMATE YOUR OPERATIONS"
  >
    <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
      <SectionLabel text="REAL AUTOMATION EXAMPLES" />
      <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 20 }}>
        {examples.map((item, index) => (
          <div key={item} style={{ display: "flex", gap: 14, alignItems: "flex-start", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.75 }}>
            <span style={{ color: "#D4A843", flexShrink: 0 }}>{index + 1}.</span>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  </StitchFeaturePage>
);

export default RpaAutomation;
